import type {ReactNode} from 'react'

export type DateRange = {begin_date: string; end_date: string}

export const emptyDateRange: DateRange = {begin_date: '', end_date: ''}

export type TaskFilterScope = 'mine' | 'instance' | 'byUser' | 'project'

export type TaskFilterValue = {
  // Além de controlar a URL (?mode=), algumas rotas usam `state.filter.mode` pra habilitar
  // os hooks de dados do Kanban (ex. useGetBacklogTasks) -- precisa ser propagado junto.
  mode?: string
  status: string
  priority: string[]
  tags: number[]
  client_id?: number[]
  project_id?: number[]
  begin_date: DateRange
  expected_date: DateRange
  end_date?: DateRange
  created_at: DateRange
  delivery_punctuality?: '' | 'on_time' | 'late'
  only_overdue_tasks: boolean
  near_due_date: boolean
  only_with_subtasks: boolean
  sort_by_delivery_date: boolean
  user_ids?: number[]
}

export type TaskFilterBarProps = {
  scope: TaskFilterScope
  hideDatesColumn: boolean
  onHideDatesColumnChange: (value: boolean) => void
  onApply: (filter: Partial<TaskFilterValue>) => void
  onSearchChange: (term: string) => void
  initialFilter?: Partial<TaskFilterValue>
  /** Slot pro botão de exportar de cada rota (cada módulo tem sua própria implementação hoje:
   *  TasksExportButton, TasksByUserExportButton — não existe um componente de export compartilhado). */
  exportButton?: ReactNode
  /** Lista de usuários pra popular o campo "Responsável". Em scope='instance' o próprio
   *  TaskFilterBar busca os usuários da instância; nos demais scopes (ex. 'project', onde o
   *  filtro é por membros do projeto, não da instância inteira) quem fornece é a rota. */
  responsibleUsers?: Array<{user_id: number; name: string}>
}
